"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceTypeChangeAllowedStatusesSafely = exports.ServiceTypeRecursiveUpdate = exports.ServiceTypeRecursiveCreate = exports.ServiceTypeUpdate = exports.ServiceTypeCreate = exports.ServiceTypeFull = exports.ServiceTypeCustomerTransport = exports.ServiceType = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../common");
const CommunicationTrigger_1 = require("./CommunicationTrigger");
const ServiceLineItemType_1 = require("./ServiceLineItemType");
const common_types_1 = require("./common-types");
exports.ServiceType = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    name: typebox_1.Type.String(),
    familyID: typebox_1.Type.String({ format: 'uuid' }),
    notes: typebox_1.Type.Optional(typebox_1.Type.String()),
    setupType: common_types_1.SetupType,
    active: typebox_1.Type.Boolean(),
    metadata: common_1.MetaData,
});
exports.ServiceTypeCustomerTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    name: typebox_1.Type.String(),
    familyID: typebox_1.Type.String({ format: 'uuid' }),
    family: typebox_1.Type.Object({ name: typebox_1.Type.String() }),
});
// Define ServiceTypeFull with Type.Any() for family to avoid circular dependency
exports.ServiceTypeFull = typebox_1.Type.Intersect([
    exports.ServiceType,
    typebox_1.Type.Object({
        family: typebox_1.Type.Object({
            id: typebox_1.Type.String({ format: 'uuid' }),
            name: typebox_1.Type.String(),
            shortCode: typebox_1.Type.String({ maxLength: 2 }),
            allowedStatuses: typebox_1.Type.Array(common_types_1.ServiceOrderStatus),
            initialStatus: typebox_1.Type.Optional(common_types_1.ServiceOrderStatus),
            communicationTriggers: typebox_1.Type.Array(CommunicationTrigger_1.CommunicationTrigger),
            lineItemTypes: typebox_1.Type.Array(ServiceLineItemType_1.ServiceLineItemType),
            serviceTypes: typebox_1.Type.Array(typebox_1.Type.Any()),
            isSubscription: typebox_1.Type.Boolean(),
            // This is temporary. These eventually will be moved to a dedicated notification service
            customerConfirmation: typebox_1.Type.Optional(typebox_1.Type.String()),
            customerOrderChanges: typebox_1.Type.Optional(typebox_1.Type.String()),
            vendorOrderChanges: typebox_1.Type.Optional(typebox_1.Type.String()),
            metadata: common_1.MetaData,
        }),
    }),
]);
exports.ServiceTypeCreate = typebox_1.Type.Omit(exports.ServiceType, ['id', 'familyID', 'metadata']);
exports.ServiceTypeUpdate = typebox_1.Type.Partial(typebox_1.Type.Omit(exports.ServiceType, ['id', 'familyID', 'metadata']));
exports.ServiceTypeRecursiveCreate = typebox_1.Type.Intersect([exports.ServiceTypeCreate]);
exports.ServiceTypeRecursiveUpdate = typebox_1.Type.Intersect([
    exports.ServiceTypeUpdate,
    typebox_1.Type.Object({
        id: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    }),
]);
exports.ServiceTypeChangeAllowedStatusesSafely = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    remove: typebox_1.Type.Array(typebox_1.Type.Object({
        status: common_types_1.ServiceOrderStatus,
        moveExistingto: common_types_1.ServiceOrderStatus,
    })),
    add: typebox_1.Type.Array(common_types_1.ServiceOrderStatus),
});
//# sourceMappingURL=ServiceType.js.map